// LIST
export const FETCH_TEMPLATES = "app/TEMPLATE/FETCH_TEMPLATES";
export const FETCH_TEMPLATES_SUCCESS = "app/TEMPLATE/FETCH_TEMPLATES_SUCCESS";
export const FETCH_TEMPLATES_FAILURE = "app/TEMPLATE/FETCH_TEMPLATES_FAILURE";

// GET VIEW DATA
export const GET_VIEW_DATA = "app/TEMPLATE/GET_VIEW_DATA";
export const GET_VIEW_DATA_SUCCESS = "app/TEMPLATE/GET_VIEW_DATA_SUCCESS";
export const GET_VIEW_DATA_FAILURE = "app/TEMPLATE/GET_VIEW_DATA_FAILURE";

// ADD
export const ADD_TEMPLATE = "app/TEMPLATE/ADD_TEMPLATE";
export const ADD_TEMPLATE_SUCCESS = "app/TEMPLATE/ADD_TEMPLATE_SUCCESS";
export const ADD_TEMPLATE_FAILURE = "app/TEMPLATE/ADD_TEMPLATE_FAILURE";

// EDIT
export const EDIT_TEMPLATE = "app/TEMPLATE/EDIT_TEMPLATE";
export const EDIT_TEMPLATE_SUCCESS = "app/TEMPLATE/EDIT_TEMPLATE_SUCCESS";
export const EDIT_TEMPLATE_FAILURE = "app/TEMPLATE/EDIT_TEMPLATE_FAILURE";

// DELETE
export const DELETE_TEMPLATE = "app/TEMPLATE/DELETE_TEMPLATE";
export const DELETE_TEMPLATE_SUCCESS = "app/TEMPLATE/DELETE_TEMPLATE_SUCCESS";
export const DELETE_TEMPLATE_FAILURE = "app/TEMPLATE/DELETE_TEMPLATE_FAILURE";

export const TOGGLE_TEMPLATE_ADD_MODAL =
  "app/TEMPLATE/TOGGLE_TEMPLATE_ADD_MODAL";
